import {CoinFlightConstants, CoinFlightView, CoreDI, Device, inject, LAYERS, Spine, SpineAnimation, UpdateManager} from '@gongxigames/framework/slot';
import {Layer} from '@pixi/layers';
import {Sprite} from 'pixi.js';

export class GameCoinFlightView extends CoinFlightView {
    @inject(CoreDI.Device)
    protected _device!: Device;
    protected _animationContainer!: Sprite;
    protected _animations: SpineAnimation[] = [];
    protected _animation!: SpineAnimation;
    protected _animationPm!: SpineAnimation;
    protected _isPortrait!: boolean;
    protected _updater: UpdateManager = new UpdateManager(true);

    public init(): void {
        super.init();
        this.updateManager.add(this._updater);
        this._animationContainer = new Sprite();
        this.container.addChild(this._animationContainer);
    }

    public startFlightAnimation(rowIndex: number, rubyBalance?: number, dimension?: number): void {
        const {SPINE_NAME, WIDE_ANIMATION_NAME, WIDE_PM_ANIMATION_NAME} = CoinFlightConstants;

        this._animation = new SpineAnimation(this.objectBuilder.buildSpine(SPINE_NAME), WIDE_ANIMATION_NAME + `${rowIndex + 1}_${dimension}x5`);
        this._animations.push(this._animation);

        if (this.isPlatformMobile()) {
            this._animationPm = new SpineAnimation(this.objectBuilder.buildSpine(SPINE_NAME), WIDE_PM_ANIMATION_NAME + `${rowIndex + 1}_${dimension}x5`);
            this._animationPm.container.visible = false;
            this._animations.push(this._animationPm);
        }

        if (this._isPortrait) {
            this._animation.container.visible = false;
            this._animationPm.container.visible = true;
        }
        this._animations.forEach(animation => {
            this._animationContainer.addChild(animation.container);
            animation.container.x = this._gameConfig.mainFrame.width / 2;
            animation.container.y = this._gameConfig.mainFrame.height / 2;
            animation.start();
            const spine = animation.container as Spine;

            spine.state.timeScale = 0.5;
            spine.state.addListener({
                event: () => {
                    this.emit(GameCoinFlightView.FLIGHT_FINISHED, rubyBalance);
                    this.reset();
                }
            });
            this._updater.add(animation);
        });
    }

    public playFlightSound(): void {
        this.soundPlayer.play('rubySymbolMove');
    }

    public reset(): void {
        this._animations.length = 0;
        this._updater.removeAll();
        this._animationContainer.removeChildren();
    }

    public onLandscape(): void {
        super.onLandscape();
        this._isPortrait = false;
        this._reelsScaleService.scaleByCurrentScreenOrientation(this.container);

        if (this._animationContainer.children.length) {
            this._animation.container.visible = true;
            this._animationPm.container.visible = false;
        }
    }

    public onPortrait(): void {
        super.onPortrait();
        this._isPortrait = true;
        this._reelsScaleService.scaleByCurrentScreenOrientation(this.container);

        if (this._animationContainer.children.length) {
            this._animation.container.visible = false;
            this._animationPm.container.visible = true;
        }
    }

    public static layer: Layer = LAYERS.TOP;
}
